/* DC · cost & earnings estimate. Six answers → public edge → ZEV PROJECTS.
   The map loads only when asked for; a pincode works without it. */
(function () {
  'use strict';
  var root = document.getElementById('zde');
  if (!root) return;
  var cfg = JSON.parse(document.getElementById('zde-config').textContent || '{}');
  var cars = JSON.parse(document.getElementById('zde-cars-data').textContent || '[]') || [];
  var products = JSON.parse((document.getElementById('zde-products') || {}).textContent || '[]') || [];
  var $ = function (id) { return document.getElementById(id); };
  var state = { lat: null, lng: null, stateCode: null, place: '', last: null };
  // The ad click that brought them, kept for the report request.
  var click = (function () {
    var q = new URLSearchParams(location.search), out = {};
    ['gclid', 'gbraid', 'wbraid'].forEach(function (k) {
      var v = q.get(k); if (v) { out[k] = v; try { sessionStorage.setItem('zde_' + k, v); } catch (e) {} }
      else { try { v = sessionStorage.getItem('zde_' + k); } catch (e) {} if (v) out[k] = v; }
    });
    return out;
  })();
  // Pincode lookup answers a state NAME; ZEV wants the RTO code.
  var STATES = { 'andhra pradesh': 'AP', 'arunachal pradesh': 'AR', 'assam': 'AS', 'bihar': 'BR',
    'chhattisgarh': 'CG', 'goa': 'GA', 'gujarat': 'GJ', 'haryana': 'HR', 'himachal pradesh': 'HP',
    'jharkhand': 'JH', 'karnataka': 'KA', 'kerala': 'KL', 'madhya pradesh': 'MP', 'maharashtra': 'MH',
    'manipur': 'MN', 'meghalaya': 'ML', 'mizoram': 'MZ', 'nagaland': 'NL', 'odisha': 'OD', 'punjab': 'PB',
    'rajasthan': 'RJ', 'sikkim': 'SK', 'tamil nadu': 'TN', 'telangana': 'TS', 'tripura': 'TR',
    'uttar pradesh': 'UP', 'uttarakhand': 'UK', 'west bengal': 'WB', 'delhi': 'DL', 'chandigarh': 'CH',
    'jammu and kashmir': 'JK', 'ladakh': 'LA', 'puducherry': 'PY', 'andaman and nicobar islands': 'AN',
    'dadra and nagar haveli and daman and diu': 'DD', 'lakshadweep': 'LD' };

  function inr(n) {
    if (n == null) return '—';
    n = Math.round(n);
    if (Math.abs(n) >= 1e7) return '₹' + (n / 1e7).toFixed(2).replace(/\.?0+$/, '') + ' Cr';
    if (Math.abs(n) >= 1e5) return '₹' + (n / 1e5).toFixed(1).replace(/\.0$/, '') + ' L';
    return '₹' + n.toLocaleString('en-IN');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function showErr(msg) { var e = $('zde-err'); e.textContent = msg || ''; e.hidden = !msg; }
  function yrs(v, horizon) { return v ? v + ' yrs' : 'over ' + (horizon || 8) + ' yrs'; }
  function profitRange(lo, hi) { return lo > 0 ? rng(lo, hi) : hi > 0 ? 'nil to ' + inr(hi) : 'nil'; }
  function rng(a, b) { var x = inr(a), y = inr(b), u = y.replace(/^[₹\d.,]+ ?/, ''); return u && x.endsWith(' ' + u) ? x.slice(0, -u.length - 1) + '–' + y.replace('₹', '') : x + ' – ' + y; }

  // ---- the form's controls ----
  function fill(r) { r.style.setProperty('--fill', ((r.value - r.min) / (r.max - r.min) * 100) + '%'); }
  $('zde-tariff').addEventListener('input', function () { $('zde-tariff-out').textContent = '₹' + this.value + ' / unit'; fill(this); });
  $('zde-hours').addEventListener('input', function () {
    $('zde-hours-out').textContent = Number(this.value) > 0 ? this.value + ' h a day' : 'typical for the site'; fill(this);
  });
  fill($('zde-tariff')); fill($('zde-hours'));
  var SITE_WORDS = { highway: 'highway stop', petrol_pump: 'petrol pump', hotel: 'hotel', mall: 'mall or restaurant', showroom: 'car showroom',
    parking: 'public parking', office: 'office', society: 'housing society', hospital: 'hospital', fleet: 'fleet depot', bus_depot: 'bus or truck depot' };
  function pickType(v) {
    $('zde-type').value = v || '';
    $('zde-chips').querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.type === v)); });
  }
  // A DC charger page's site picker links here with the site it was told (?site=<type>).
  (function () { var t = new URLSearchParams(location.search).get('site'); if (t && SITE_WORDS[t]) pickType(t); })();
  // Ads -> Website in DataVault (snippets/zev-analytics.liquid): started, saw the numbers, asked for the report.
  var zvaStarted = false;
  function zva(name, props) { try { if (window.zva) window.zva.track(name, props); } catch (e) {} }
  function zvaStart() { if (!zvaStarted) { zvaStarted = true; zva('estimate_open'); } }
  root.addEventListener('focusin', zvaStart);
  root.addEventListener('click', zvaStart);
  $('zde-chips').addEventListener('click', function (ev) { var b = ev.target.closest('button'); if (b) pickType(b.dataset.type); });
  root.querySelectorAll('.zde__stepper button').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = $('zde-bays'), v = Number(i.value) + Number(b.dataset.step);
      i.value = Math.min(60, Math.max(2, v));
    });
  });

  // ---- where: pincode ----
  var pinTimer, pinReady;
  $('zde-pin').addEventListener('input', function () {
    var pin = this.value.replace(/\D/g, '');
    this.value = pin;
    clearTimeout(pinTimer);
    if (pin.length !== 6) return;
    pinReady = new Promise(function (done) {
      pinTimer = setTimeout(function () {
        fetch(cfg.pincodeApi + pin).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          if (!d || !d.state) { setPlace(null, null, null, ''); return done(); }
          setPlace(null, null, STATES[String(d.state).toLowerCase()] || null, (d.city ? d.city + ', ' : '') + d.state);
          done();
        }).catch(done);
      }, 250);
    });
  });
  function setPlace(lat, lng, code, label) {
    state.lat = lat; state.lng = lng; state.stateCode = code; state.place = label;
    var p = $('zde-place'); p.textContent = label ? '📍 ' + label : ''; p.hidden = !label;
  }

  // ---- try an example: fill the form and run it ----
  $('zde-empty').addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-example]'); if (!b) return;
    var parts = b.dataset.example.split('|');
    var pin = $('zde-pin'); pin.value = parts[0]; pin.dispatchEvent(new Event('input', { bubbles: true }));
    pickType(parts[1]); $('zde-bays').value = parts[2];
    (pinReady || Promise.resolve()).then(function () { $('zde-form').requestSubmit(); });
  });

  // ---- where: map, loaded only on request ----
  var map, marker, mapsLoading;
  $('zde-map-btn').addEventListener('click', function () {
    if (!cfg.mapsKey) { showErr('The map is not available right now. Enter the pincode instead.'); return; }
    var box = $('zde-map'); box.hidden = false;
    if (map || mapsLoading) return;
    mapsLoading = true;
    window.__zdeMapReady = function () {
      var start = { lat: 28.6139, lng: 77.2090 };
      map = new google.maps.Map(box, { center: start, zoom: 5, mapTypeControl: false, streetViewControl: false, fullscreenControl: false });
      marker = new google.maps.Marker({ map: map, position: start, draggable: true, title: 'Drag to your site' });
      function pick(ll) { marker.setPosition(ll); setPlace(ll.lat(), ll.lng(), null, 'Pin placed · ' + ll.lat().toFixed(4) + ', ' + ll.lng().toFixed(4)); }
      map.addListener('click', function (e) { pick(e.latLng); });
      marker.addListener('dragend', function (e) { pick(e.latLng); });
      if (navigator.geolocation) navigator.geolocation.getCurrentPosition(function (pos) {
        var ll = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
        map.setCenter(ll); map.setZoom(14); pick(ll);
      }, function () {});
    };
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(cfg.mapsKey) + '&loading=async&callback=__zdeMapReady';
    s.async = true; s.onerror = function () { showErr('The map could not load. Enter the pincode instead.'); };
    document.head.appendChild(s);
  });

  // ---- bot check ----
  function token(action) {
    return new Promise(function (resolve) {
      if (!cfg.recaptchaKey || typeof grecaptcha === 'undefined' || !grecaptcha.enterprise) return resolve('');
      grecaptcha.enterprise.ready(function () {
        grecaptcha.enterprise.execute(cfg.recaptchaKey, { action: action }).then(resolve, function () { resolve(''); });
      });
    });
  }
  function busy(on) { $('zde-skeleton').hidden = !on; if (on) { $('zde-empty').hidden = true; $('zde-result').hidden = true; } }

  // ---- submit ----
  $('zde-form').addEventListener('submit', function (ev) {
    ev.preventDefault(); showErr('');
    var type = $('zde-type').value, bays = Number($('zde-bays').value);
    if (state.lat == null && !state.stateCode) return showErr('Enter the site pincode or pick it on the map.');
    if (!type) return showErr('Pick the kind of site.');
    if (!(bays >= 2 && bays <= 60)) return showErr('Charging bays must be between 2 and 60.');
    var body = { site_type: type, bays: bays, solar: $('zde-solar').checked, tariff_per_kwh: Number($('zde-tariff').value) };
    var hours = Number($('zde-hours').value); if (hours > 0) body.hours_per_day = hours;
    if (state.lat != null) { body.lat = state.lat; body.lng = state.lng; } else body.state_code = state.stateCode;
    state.last = { answers: body };
    var btn = $('zde-go'); btn.disabled = true; btn.firstElementChild.textContent = 'Working it out…'; busy(true);
    if (window.innerWidth < 990) $('zde-skeleton').scrollIntoView({ behavior: 'smooth', block: 'start' });
    token('dc_quick_estimate').then(function (t) {
      body.recaptcha_token = t;
      return fetch(cfg.api + '/quick-estimate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { busy(false); $('zde-empty').hidden = false; return showErr((res.d && res.d.error) || 'The estimate could not be made. Try again.'); }
        state.last.estimate = res.d; $('zde-sent').hidden = true; $('zde-report').hidden = false;
        zva('pdp_estimate', { site: type, bays: bays });
        render(res.d);
      }).catch(function () { busy(false); $('zde-empty').hidden = false; showErr('The estimate could not be made. Check your connection and try again.'); })
      .then(function () { btn.disabled = false; btn.firstElementChild.textContent = 'See the numbers'; });
  });

  // ---- the full report: the request is the lead ----
  $('zde-report').addEventListener('submit', function (ev) {
    ev.preventDefault();
    var err = $('zde-report-err'); err.hidden = true;
    if (!state.last || !state.last.estimate) { err.textContent = 'Make the estimate first.'; err.hidden = false; return; }
    var contact = { name: $('zde-name').value.trim(), mobile: $('zde-mobile').value.trim(),
                    email: $('zde-email').value.trim(), company: $('zde-company').value.trim() };
    if (contact.name.length < 2) { err.textContent = 'Tell us your name.'; err.hidden = false; return; }
    if (contact.mobile.replace(/\D/g, '').length < 10) { err.textContent = 'Enter your 10-digit mobile number.'; err.hidden = false; return; }
    var btn = $('zde-report-go'); btn.disabled = true; btn.firstElementChild.textContent = 'Sending…';
    zva('form_sent', { form: 'dc-estimate-report' });
    try { if (window.zva) { window.zva.identify('phone', contact.mobile, 'form'); if (contact.email) window.zva.identify('email', contact.email, 'form'); } } catch (e) {}
    token('dc_report_request').then(function (t) {
      return fetch(cfg.api + '/quick-estimate/report', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contact: contact, answers: state.last.answers, estimate: state.last.estimate, click: click,
                               page_url: location.href.split('#')[0], recaptcha_token: t }) });
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { err.textContent = (res.d && res.d.error) || 'Could not send the report. Try again.'; err.hidden = false; return; }
        $('zde-sent-link').href = res.d.url;
        $('zde-sent-text').textContent = (res.d.emailed ? 'Emailed to you too. ' : '') + 'An engineer will call you within a working day.';
        $('zde-report').hidden = true; $('zde-sent').hidden = false;
      }).catch(function () { err.textContent = 'Could not send the report. Check your connection and try again.'; err.hidden = false; })
      .then(function () { btn.disabled = false; btn.firstElementChild.textContent = 'Send me the full report'; });
  });

  // ---- render ----
  function render(d) {
    var c = d.cost, e = d.earnings, p = d.power, pb = d.payback, st = d.site || {};
    var where = [st.city, st.state_name].filter(Boolean).join(', ') || (state.place || '').replace(/^📍 /, '');
    $('zde-site-line').textContent = (SITE_WORDS[st.site_type] || 'site') + ' · ' + st.bays + ' bays' + (where ? ' · ' + where : '');
    $('zde-verdict').innerHTML = pb.years
      ? 'Could pay back in about <b>' + esc(pb.years) + ' years</b>.'
      : 'Unlikely to pay back within ' + esc(pb.horizon_years || 8) + ' years at this use.';
    $('zde-cost').textContent = inr(c.likely_inr);
    $('zde-cost-range').textContent = 'before GST';
    // Profit, not takings: what is left after the electricity and upkeep.
    $('zde-earn').textContent = e.net_monthly_likely_inr > 0 ? inr(e.net_monthly_likely_inr) : 'Nil';
    $('zde-earn-range').textContent = 'a month, after running costs';
    $('zde-payback').textContent = yrs(pb.years, pb.horizon_years);
    $('zde-net').textContent = pb.years_low ? (pb.years_high ? pb.years_low + '–' + pb.years_high + ' yrs' : pb.years_low + ' yrs or more') : '';
    $('zde-supply').textContent = p.connection || '—';
    $('zde-supply-note').textContent = p.connection === 'HT' ? 'transformer needed' : 'no transformer';
    $('zde-power-note').textContent = (p.connection === 'HT'
      ? 'Over the ' + p.lt_ceiling_kw + ' kW LT limit in this state, so the site needs a transformer and an HT connection.'
      : 'Within the ' + p.lt_ceiling_kw + ' kW LT limit in this state, so no transformer is needed.')
      + ' Cost ' + rng(c.low_inr, c.high_inr) + '.'
      + (e.net_monthly_high_inr != null ? ' Profit ' + profitRange(e.net_monthly_low_inr, e.net_monthly_high_inr) + ' a month, quiet to busy.' : '');
    $('zde-chargers-line').textContent = (d.chargers || []).map(function (ch) { return ch.qty + ' × ' + ch.model + (ch.guns > 1 ? ' (' + ch.guns + ' guns)' : ''); }).join(' + ')
      + (st.guns ? ' · ' + st.guns + ' cars at once' : '');
    $('zde-thumbs').innerHTML = (d.chargers || []).map(function (ch) {
      var m = String(ch.model || '').toLowerCase(), hit = products.find(function (p) { return p.image && p.title.toLowerCase().indexOf(m) === 0; });
      return hit ? '<a href="' + esc(hit.url) + '" title="' + esc(hit.title) + '"><img src="' + esc(hit.image) + '" alt="' + esc(ch.model) + '" loading="lazy"></a>' : '';
    }).join('');
    var ul = $('zde-chargers'); ul.innerHTML = '';
    (d.chargers || []).forEach(function (ch) {
      ul.insertAdjacentHTML('beforeend', '<li><b>' + ch.qty + ' × ' + esc(ch.model) + '</b><span>' + (ch.guns > 1 ? ch.guns + ' guns · ' : '') + ch.kw + ' kW · ' + inr(ch.unit_price_inr) + '</span></li>');
    });
    $('zde-guns').textContent = st.guns ? st.guns + (st.guns === 1 ? ' car charges' : ' cars charge') + ' at once across your ' + st.bays + ' bays.' : '';
    renderCars(d.chargers || []);
    $('zde-more').open = false;
    around(state.last.answers);
    var comp = $('zde-competition');
    if (d.competition) { comp.hidden = false; comp.textContent = d.competition.within_3km
      ? d.competition.within_3km + ' public charger' + (d.competition.within_3km === 1 ? '' : 's') + ' within 3 km of the pin, the nearest ' + d.competition.nearest_km + ' km away.'
      : 'No public charger within 3 km of the pin' + (d.competition.within_10km ? ' (' + d.competition.within_10km + ' within 10 km).' : '.'); } else comp.hidden = true;
    var sol = $('zde-solar-line');
    if (d.solar) { sol.hidden = false; sol.textContent = 'Solar: ' + d.solar.kwp + ' kWp on the canopy saves about ' + inr(d.solar.annual_saving_inr) + ' a year' + (d.solar.payback_years ? ', back in ' + d.solar.payback_years + ' years.' : '.'); } else sol.hidden = true;
    $('zde-assumptions').innerHTML = (d.assumptions || []).map(function (a) { return '<li>' + esc(a) + '</li>'; }).join('');
    if (d.caveat) $('zde-caveat').textContent = d.caveat;
    busy(false); var out = $('zde-result'); out.classList.remove('is-in'); out.hidden = false; void out.offsetWidth; out.classList.add('is-in');
    if (window.innerWidth < 990) out.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ---- around the site: fills in after the numbers, never waited for ----
  function plural(n, w) { return n + ' ' + (n === 1 ? w : w === 'petrol pump' ? 'petrol pumps' : w + 's'); }
  function around(body) {
    var box = $('zde-around'); box.hidden = true; $('zde-around-line').hidden = true;
    var where = body.lat != null ? { lat: body.lat, lng: body.lng } : { pincode: $('zde-pin').value };
    if (!where.lat && !where.pincode) return;
    fetch(cfg.api + '/quick-estimate/surroundings', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(where) })
      .then(function (r) { return r.ok ? r.json() : {}; }).then(function (d) {
        if (!d || !d.counts) return;
        var keys = Object.keys(d.counts).sort(function (a, b) { return d.counts[b] - d.counts[a]; });
        var parts = keys.map(function (k) { return plural(d.counts[k], k); });
        $('zde-around-counts').textContent = parts.length
          ? 'Within 3 km: ' + parts.join(', ') + '.'
          : 'Not much within 3 km of this pin.';
        $('zde-around-places').innerHTML = (d.named || []).map(function (p) {
          return '<li><span><b>' + esc(p.name) + '</b><small>' + esc(p.kind) + ' · ' + p.km + ' km</small></span><em>' + p.rating + ' ★</em></li>';
        }).join('');
        var ch = d.chargers || {};
        $('zde-around-chargers').textContent = ch.within_5km
          ? (ch.capped ? '20+ public charging points' : plural(ch.within_5km, 'public charging point')) + ' within 5 km · nearest ' + ch.nearest_km + ' km.'
          : 'No public charging point within 5 km: an open spot.';
        $('zde-competition').hidden = true;
        box.hidden = false;
        var line = $('zde-around-line'); line.hidden = false;
        line.textContent = (keys.length ? 'Nearby: ' + parts.slice(0, 3).join(', ') : 'Not much nearby') + (ch.within_5km ? ' · ' + (ch.capped ? '20+' : ch.within_5km) + ' charging points within 5 km' : ' · no charging point within 5 km');
      }).catch(function () {});
  }

  function renderCars(chargers) {
    var maxKw = 0; chargers.forEach(function (ch) { if (ch.type === 'DC' && ch.kw > maxKw) maxKw = ch.kw; });
    var el = $('zde-cars');
    if (!maxKw || !cars.length) { el.textContent = ''; return; }
    var full = cars.filter(function (x) { return x.dc && x.dc <= maxKw; });
    el.innerHTML = '<b>' + full.length + ' of ' + cars.length + '</b> EVs sold in India get their full speed here.';
  }
})();
